import React from "react"
import "./FormThankYou.css";
import IconButton from '@material-ui/core/IconButton';
import FacebookIcon from '@material-ui/icons/Facebook';
import InstagramIcon from '@material-ui/icons/Instagram';

function FormFaliure() {
  return (
    <div className="formRouteMainContainer">
      <div className="formThankYouMain">
        <div className="formThankYouContainer">
          <div className="formThankYouHeader">
            <div className="formThankYouHeaderContent">There was a error</div>
          </div>
          <div className="formThankYouContent">
            <p>
              There seems to have been an error and we currently working on solving the issue.
              We sincerely apologise for this inconvenience. Please try again later.
              <br /><br />
              In the meantime, you can check out our <a href="https://moveit.motorvia.co.za/Moveit/document?doc=costfactors" target="_blank">FAQ</a> that
              could affect your quoteor contact us on our
              social media platforms below.
            </p>
          </div>
          <div className="formThankYouFooter">
            <div className="formThankYouFooterContent">
              <IconButton href="https://www.facebook.com/MotorviaSA/" target="_blank">
                <FacebookIcon />
              </IconButton>
              <IconButton href="https://www.instagram.com/motorvia_sa/" target="_blank">
                <InstagramIcon />
              </IconButton>
            </div>
          </div>
          <div className="buttonSpacer"></div>
        </div>
      </div>
    </div>

  )
}

export default FormFaliure
